import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "gfu-notification-card" }
const _hoisted_2 = { class: "_ma-0 _flex _jc-sb" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-bt gfu-bt--caption _tc--lighter _ttu"
}
const _hoisted_4 = {
  key: 0,
  class: "_ma-0"
}
const _hoisted_5 = {
  key: 0,
  class: "gfu-notification-card__actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_notification_delivery_time = _resolveComponent("notification-delivery-time")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_resolveDynamicComponent($options.wrapperElement.tag), _mergeProps($options.wrapperElement.props, { class: "gfu-link--nofx _block" }), {
    default: _withCtx(() => [
      _createVNode(_component_base_card, { "extended-wrapper-class": "_flexrow _pa-1" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_image, {
              width: "80",
              height: "80",
              src: $props.imageUrl,
              alt: "notification image",
              loading: "lazy",
              class: "gfu-notification-card__image _rounded--common"
            }, null, 8 /* PROPS */, ["src"]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "message-title", {}, () => [
                  ($props.messageTitle)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($props.messageTitle), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                ($props.createdAt)
                  ? (_openBlock(), _createBlock(_component_notification_delivery_time, {
                      key: 0,
                      class: "gfu-bt gfu-bt--caption _tc--lighter _shrink-0",
                      timestamp: $options.notificationCreatedAt
                    }, null, 8 /* PROPS */, ["timestamp"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _renderSlot(_ctx.$slots, "message-text", {}, () => [
                ($props.messageText)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString($props.messageText), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            ($options.hasActions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "actions")
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 3 /* FORWARDED */
      })
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}